export const StatsBarSection = () => {
  return (
    <section
      className="hero-statsbar"
      style={{
        background: "#fff",
        borderTop: "1px solid var(--isa-dk)",
        borderBottom: "1px solid var(--isa-dk)",
      }}
    >
      <div className="hstat">
        <div className="hstat-icon">✦</div>
        <div className="hstat-n">40<em>+</em></div>
        <div className="hstat-l">Smart-Match Variables</div>
      </div>
      <div className="hstat-div" />

      <div className="hstat">
        <div className="hstat-icon">◉</div>
        <div className="hstat-n">100<em>%</em></div>
        <div className="hstat-l">Vetted Designers</div>
      </div>
      <div className="hstat-div" />

      <div className="hstat">
        <div className="hstat-icon">◎</div>
        <div className="hstat-n"><em>Perfect</em></div>
        <div className="hstat-l">Match Guarantee</div>
      </div>
    </section>
  );
};
